import { render, staticRenderFns } from "./GetById.vue?vue&type=template&id=7948f318&scoped=true"
import script from "./GetById.vue?vue&type=script&lang=js"
export * from "./GetById.vue?vue&type=script&lang=js"
import style0 from "./GetById.vue?vue&type=style&index=0&id=7948f318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7948f318",
  null
  
)

export default component.exports